import React,{useState} from 'react';
import {connect} from 'react-redux';
import {Redirect} from 'react-router-dom';
import SunEditor,{buttonList} from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import {handleAuthor_id} from '../../Utils';

const AddContent = ({tokenObject,connection,setSuccessfulMessage}) => {

    const [Title,setTitle] = useState("");
    const [Content,setContent] = useState("");
    const [Email,setEmail] = useState("");
    const [Category,setCategory] = useState("");
    const [CategoryList,setCategoryList] = useState([]);
    const [wasSucceded,setWasSucceded] = useState(false);

    if(tokenObject.token === ""){
        return(
            <Redirect to="/login"/>
        );
    }

    async function createContent(){

        const Author_id = await handleAuthor_id(Email,connection,tokenObject);

        const result = await connection.post("/Contents",{
            Author_id:Author_id,
            Title:Title,
            Content:Content,
            Category:Category
        },{
            headers:{
                'user-access-token':tokenObject.token
            }
        });

        setWasSucceded(setSuccessfulMessage(result.status));

    }

    (async function getEmail(){
        if(Email === ""){
            const result = await connection.get('/User',{
                headers:{
                    'user-access-token':tokenObject.token
                }
            });
            document.querySelector("#InputEmail").value = result.data.Email;
            setEmail(result.data.Email);
        }
    })();

    (async function getCategories(){
        if(CategoryList.length === 0){
            const result = await connection.get('/Categories',{
                headers:{
                    'user-access-token':tokenObject.token
                }
            });

            const localCategories = [];
            
            result.data.forEach((value) => {
                localCategories.push(value);
            });

            setCategoryList(localCategories);

        }
    })();

    function handleTitle(event){
        setTitle(event.target.value);
    }

    function handleContent(contents){
        setContent(contents); 
    }

    function handleEmail(event){
        setEmail(event.target.value);
    }

    function handleCategory(event){
        setCategory(event.target.value);
    }

    return(
        <>
            <br/>
            {(function(){
                return wasSucceded ? (
                <div class="alert alert-success" role="alert">
                    Content successfully created!
                </div>) : (<></>)
                }
                )()}
            <h1>Add Content</h1>
                <div className="mb-3">
                    <label htmlFor="exampleInputEmail1" className="form-label">Email address</label>
                    <input type="email" className="form-control" id="InputEmail" aria-describedby="emailHelp" onKeyUp={handleEmail}/>
                    <div id="emailHelp" className="form-text">We'll never share your email with anyone else.</div>
                </div>
                <div className="mb-3">
                    <label htmlFor="exampleInputEmail1" className="form-label">Title</label>
                    <input type="text" className="form-control" id="InputTextTitle" aria-describedby="emailHelp" onKeyUp={handleTitle}/>
                </div>
                <div className="mb-3">
                <label htmlFor="form-select" className="form-label">Category</label>
                    <select class="form-select" aria-label="Default select example" onChange={handleCategory}>
                        <option value = "" selected>Select a category</option>
                        {CategoryList.map((value,index) => (
                                 <option key = {index} value = {value.Name}>{value.Name}</option>
                        ))}
                    </select>
                </div>
                <div>
                    <label htmlFor="validationTextarea" className="form-label">Content</label>
                    <SunEditor onChange={handleContent} setOptions={
                        {
                            height:300,
                            buttonList:buttonList.complex
                        }
                    }/>  
                </div>  
                <button className="btn btn-primary" onClick={createContent}>Submit</button>
        </>
    )
}

const mapStateToProps = (state) => ({
    tokenObject: state.token
});

export default connect(mapStateToProps)(AddContent);